export const translations = {
  fr: {
    // Navigation
    nav: {
      dashboard: 'Tableau de bord',
      matrix: 'Ma Matrice',
      wallet: 'Portefeuille',
      commissions: 'Commissions',
      referrals: 'Parrainages',
      profile: 'Profil',
      logout: 'Déconnexion',
      login: 'Connexion',
      register: "S'inscrire"
    },
    
    // Auth
    auth: {
      login: 'Connexion',
      register: "Inscription",
      email: 'Adresse email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      name: 'Nom complet',
      sponsorCode: 'Code parrain (optionnel)',
      loginBtn: 'Se connecter',
      registerBtn: "S'inscrire",
      orContinueWith: 'Ou continuer avec',
      googleLogin: 'Google',
      noAccount: "Pas encore de compte ?",
      hasAccount: 'Déjà un compte ?',
      createAccount: 'Créer un compte',
      welcomeBack: 'Bon retour parmi nous',
      joinUs: 'Rejoignez notre réseau',
      forgotPassword: 'Mot de passe oublié ?'
    },
    
    // Dashboard
    dashboard: {
      title: 'Tableau de bord',
      welcome: 'Bienvenue',
      totalMembers: 'Membres totaux',
      directReferrals: 'Parrainages directs',
      totalDownline: 'Réseau total',
      monthlyIncome: 'Revenu mensuel',
      totalIncome: 'Revenu total',
      reserveBalance: 'Solde réserve',
      currentLevel: 'Niveau actuel',
      matrixFilled: 'Matrice remplie',
      nextPayout: 'Prochain paiement',
      recentActivity: 'Activité récente',
      quickActions: 'Actions rapides',
      viewMatrix: 'Voir ma matrice',
      inviteMember: 'Inviter un membre',
      withdrawFunds: 'Retirer des fonds'
    },
    
    // Matrix
    matrix: {
      title: 'Ma Matrice',
      orbitView: 'Vue Orbite',
      listView: 'Vue Liste',
      north: 'Nord',
      south: 'Sud',
      east: 'Est',
      west: 'Ouest',
      level: 'Niveau',
      position: 'Position',
      members: 'Membres',
      empty: 'Position vide',
      totalDownline: 'Réseau total',
      directMembers: 'Membres directs',
      clickToExpand: 'Cliquer pour développer',
      zoomIn: 'Zoom +',
      zoomOut: 'Zoom -',
      reset: 'Réinitialiser'
    },
    
    // Wallet
    wallet: {
      title: 'Portefeuille',
      balance: 'Solde disponible',
      income: 'Entrées',
      expenses: 'Sorties',
      reserve: 'Réserve',
      transactions: 'Historique des transactions',
      withdrawal: 'Demande de retrait',
      withdrawAmount: 'Montant à retirer',
      withdraw: 'Retirer',
      minWithdrawal: 'Retrait minimum: $10',
      noTransactions: 'Aucune transaction',
      date: 'Date',
      type: 'Type',
      amount: 'Montant',
      description: 'Description',
      membership: 'Adhésion',
      commission: 'Commission',
      pending: 'En attente'
    },
    
    // Commissions
    commissions: {
      title: 'Commissions',
      summary: 'Résumé',
      history: 'Historique',
      byLevel: 'Par niveau',
      totalEarned: 'Total gagné',
      fromUser: 'De',
      levelCommission: 'Commission niveau',
      noCommissions: 'Aucune commission',
      rate: 'Taux: 2.5% par niveau',
      maxLevels: '7 niveaux maximum'
    },
    
    // Referrals
    referrals: {
      title: 'Parrainages',
      yourLink: 'Votre lien de parrainage',
      copyLink: 'Copier le lien',
      copied: 'Copié !',
      shareOn: 'Partager sur',
      directReferrals: 'Parrainages directs',
      noReferrals: 'Aucun parrainage',
      inviteText: "Rejoignez mon réseau MLM et gagnez des commissions !"
    },
    
    // Profile
    profile: {
      title: 'Mon Profil',
      personalInfo: 'Informations personnelles',
      settings: 'Paramètres',
      language: 'Langue',
      save: 'Enregistrer',
      saved: 'Enregistré !',
      memberSince: 'Membre depuis',
      referralCode: 'Code parrain',
      sponsor: 'Parrain'
    },
    
    // Membership
    membership: {
      title: 'Adhésion',
      price: 'Prix mensuel',
      netAmount: 'Montant net',
      reserveAmount: 'Montant réserve',
      activate: 'Activer mon adhésion',
      active: 'Adhésion active',
      description: 'Votre adhésion comprend'
    },
    
    // Common
    common: {
      loading: 'Chargement...',
      error: 'Une erreur est survenue',
      success: 'Succès',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      view: 'Voir',
      back: 'Retour',
      next: 'Suivant',
      previous: 'Précédent',
      search: 'Rechercher',
      filter: 'Filtrer',
      export: 'Exporter',
      noData: 'Aucune donnée',
      of: 'sur'
    },
    
    // MLM specific
    mlm: {
      forcedMatrix: 'Matrice Forcée 4x7',
      membershipFee: 'Frais d\'adhésion',
      commissionRate: 'Taux de commission',
      perLevel: 'par niveau',
      maxDepth: 'Profondeur maximale',
      maxWidth: 'Largeur maximale',
      levels: 'niveaux',
      positions: 'positions'
    }
  },
  
  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      matrix: 'My Matrix',
      wallet: 'Wallet',
      commissions: 'Commissions',
      referrals: 'Referrals',
      profile: 'Profile',
      logout: 'Logout',
      login: 'Login',
      register: 'Sign Up'
    },
    
    // Auth
    auth: {
      login: 'Login',
      register: 'Sign Up',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      name: 'Full name',
      sponsorCode: 'Sponsor code (optional)',
      loginBtn: 'Sign in',
      registerBtn: 'Sign up',
      orContinueWith: 'Or continue with',
      googleLogin: 'Google',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      createAccount: 'Create account',
      welcomeBack: 'Welcome back',
      joinUs: 'Join our network',
      forgotPassword: 'Forgot password?'
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      totalMembers: 'Total Members',
      directReferrals: 'Direct Referrals',
      totalDownline: 'Total Downline',
      monthlyIncome: 'Monthly Income',
      totalIncome: 'Total Income',
      reserveBalance: 'Reserve Balance',
      currentLevel: 'Current Level',
      matrixFilled: 'Matrix Filled',
      nextPayout: 'Next Payout',
      recentActivity: 'Recent Activity',
      quickActions: 'Quick Actions',
      viewMatrix: 'View my matrix',
      inviteMember: 'Invite a member',
      withdrawFunds: 'Withdraw funds'
    },
    
    // Matrix
    matrix: {
      title: 'My Matrix',
      orbitView: 'Orbit View',
      listView: 'List View',
      north: 'North',
      south: 'South',
      east: 'East',
      west: 'West',
      level: 'Level',
      position: 'Position',
      members: 'Members',
      empty: 'Empty position',
      totalDownline: 'Total downline',
      directMembers: 'Direct members',
      clickToExpand: 'Click to expand',
      zoomIn: 'Zoom +',
      zoomOut: 'Zoom -',
      reset: 'Reset'
    },
    
    // Wallet
    wallet: {
      title: 'Wallet',
      balance: 'Available Balance',
      income: 'Income',
      expenses: 'Expenses',
      reserve: 'Reserve',
      transactions: 'Transaction History',
      withdrawal: 'Withdrawal Request',
      withdrawAmount: 'Amount to withdraw',
      withdraw: 'Withdraw',
      minWithdrawal: 'Minimum withdrawal: $10',
      noTransactions: 'No transactions',
      date: 'Date',
      type: 'Type',
      amount: 'Amount',
      description: 'Description',
      membership: 'Membership',
      commission: 'Commission',
      pending: 'Pending'
    },
    
    // Commissions
    commissions: {
      title: 'Commissions',
      summary: 'Summary',
      history: 'History',
      byLevel: 'By Level',
      totalEarned: 'Total Earned',
      fromUser: 'From',
      levelCommission: 'Level commission',
      noCommissions: 'No commissions',
      rate: 'Rate: 2.5% per level',
      maxLevels: '7 levels maximum'
    },
    
    // Referrals
    referrals: {
      title: 'Referrals',
      yourLink: 'Your referral link',
      copyLink: 'Copy link',
      copied: 'Copied!',
      shareOn: 'Share on',
      directReferrals: 'Direct referrals',
      noReferrals: 'No referrals',
      inviteText: 'Join my MLM network and earn commissions!'
    },
    
    // Profile
    profile: {
      title: 'My Profile',
      personalInfo: 'Personal Information',
      settings: 'Settings',
      language: 'Language',
      save: 'Save',
      saved: 'Saved!',
      memberSince: 'Member since',
      referralCode: 'Referral code',
      sponsor: 'Sponsor'
    },
    
    // Membership
    membership: {
      title: 'Membership',
      price: 'Monthly price',
      netAmount: 'Net amount',
      reserveAmount: 'Reserve amount',
      activate: 'Activate my membership',
      active: 'Active membership',
      description: 'Your membership includes'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      success: 'Success',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      noData: 'No data',
      of: 'of'
    },
    
    // MLM specific
    mlm: {
      forcedMatrix: 'Forced Matrix 4x7',
      membershipFee: 'Membership fee',
      commissionRate: 'Commission rate',
      perLevel: 'per level',
      maxDepth: 'Maximum depth',
      maxWidth: 'Maximum width',
      levels: 'levels',
      positions: 'positions'
    }
  }
};

export const getPositionLabel = (position, lang = 'fr') => {
  const labels = {
    fr: { N: 'Nord', S: 'Sud', E: 'Est', W: 'Ouest' },
    en: { N: 'North', S: 'South', E: 'East', W: 'West' }
  };
  return labels[lang]?.[position] || position;
};
